<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch3">
<div class="chapterHead"><p class="centerImage0"><img alt="image" src="images/ch3.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">“That’s enough out of you three! You’re always making trouble,” the red-faced Mr. Dunning sputters. “If you hate history so much, you can just wait for the rest of us in the lobby.”</p>
<p class="para" style="text-indent: 5%;">“Oh, brother,” you groan. “There goes our fun.”</p>
<p class="para" style="text-indent: 5%;">Minutes later, the bus pulls up to a stone building. Mr. Dunning leads the class into the lobby of the Wicked Wax Museum.</p>
<p class="para" style="text-indent: 5%;">A scowling woman in a purple turban and gold bracelets sits inside a ticket booth. “These three students will not be going in,” Mr. Dunning tells her. He turns to you, Jake, and Liz and points to a bench by the wall. “Sit there, you little monsters. And you’d better still be sitting there when I come back!”</p>
<p class="para" style="text-indent: 5%;">The class leaves you behind as they enter the Hall of Historical Exhibits. A red door closes after them. Jake manages to sit still for a few minutes. Then he jumps up and says, “I think it’s time for us to take a little tour of our own.”</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Turn to <span href="#/e9780545841733_ch075" title="Link target outside of Sample">PAGE 75</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841733_ch003.vue?94ec7602